import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';

import Loading from 'components/Loading';
import partitionSubscriptions from './partitionSubscriptions';
import ActivatedPlanCard from 'components/ActivatedPlanCard';
import { GET_MY_SUBSCRIPTIONS } from 'queries/subscription';

import SubscriptionPlanHistory from './components/SubscriptionPlanHistory';

export default function SubscriptionPlanList() {
  const { t } = useTranslation();
  const { data, loading } = useQuery(GET_MY_SUBSCRIPTIONS, {
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return <Loading size="xl" />;
  }

  const { mySubscriptions } = data;
  const { activeSubscriptions, inactiveSubscriptions } = partitionSubscriptions(mySubscriptions);

  return (
    <div>
      {
        !activeSubscriptions.length && (
          <div className="text-center">{t('my_subscriptions.no_active')}</div>
        )
      }
      {
        activeSubscriptions.map(subscription => (
          <ActivatedPlanCard
            key={subscription.id}
            product={subscription.product}
            serialNumber={subscription.device.serialNumber}
            subscription={subscription}
            showCollapse={true}
            showCancel={true}
          />
        ))
      }
      <SubscriptionPlanHistory subscriptions={inactiveSubscriptions} />
    </div>
  )
}
